import React from 'react';
import styled from 'styled-components';
import {
    EditorBlock,
    Modifier,
    EditorState,
    SelectionState
} from 'draft-js'
import { Dropdown, Button, TextField, Animation } from 'components'
import { FaPlay } from 'react-icons/fa'
// import { ToggleButton } from 'features'
import ToggleButton from './ToggleButton'
import { AnimatePresence } from "framer-motion"

import classes from './CodeBlock.module.css'

export const CodeBlock = (props) => {
    const blockProps = props.block.getData()
    const [syntax, setSyntax] = React.useState(blockProps.get('syntax'))
    const [show, setShow] = React.useState(true)
    const [title, setTitle] = React.useState(blockProps.get('title'))

    // Dropdown
    const dropdownStyle = {
        backgroundColor: 'var(--primary-accent-color)',
        fontSize: '0.8rem',
        padding: '0.3rem 0.5rem',
        width: 'fit-content',
        placement: 'bottom-start'
    }

    const onSelectSyntax = (value) => {
        let updatedProps = blockProps.toJS()
        updatedProps['syntax'] = value
        let selectionState = props.blockProps.editorState.getSelection()
        const startKey = selectionState.anchorKey;
        const endKey = selectionState.focusKey
        selectionState = selectionState.merge({
            focusKey: startKey,
            focusOffset: 0, 
            anchorKey: endKey,
            anchorOffset: 0,
            isBackward: false
        })
        const newContentState = Modifier.setBlockData(props.contentState, SelectionState.createEmpty(props.block.getKey()), updatedProps)
        let newState = EditorState.push(props.blockProps.editorState, newContentState, 'code-block-syntax')
        newState = EditorState.forceSelection(newState, selectionState)
        props.blockProps.setEditorState(newState)
        setSyntax(value)
    }

    const onTitle = (event) => {
        setTitle(event.target.value)
    }

    const commitTitle = () => {
        console.log('commitTitle')
        props.blockProps.setReadOnly(false)
        let updatedProps = blockProps.toJS()
        updatedProps['title'] = title
        const newContentState = Modifier.setBlockData(props.contentState, SelectionState.createEmpty(props.block.getKey()), updatedProps)
        let newState = EditorState.push(props.blockProps.editorState, newContentState, 'code-block-syntax')
        props.blockProps.setEditorState(newState)
    }

    const updatedProps = Object.assign({...props}, {forceSelection: false}) // To fix title selection issue
    return (
        <div className={classes.Container}>
            <div className={classes.Title}>
                <ToggleButton onSelect={() => setShow(!show)} open={show} styles={{backgroundColor: 'var(--primary-color)'}}/>
                <TextField value={title} onKeyDown={onTitle} onKeyPress={onTitle} onChange={onTitle} onBlur={commitTitle}
                    placeholder='Code block' style={{fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace', fontSize: '0.9rem'}}
                    onSelect={() => props.blockProps.setReadOnly(true)}/>
            </div>
            <AnimatePresence initial={false}>
            {show && 
                <Animation animation='expand'>
                    <div className={classes.Body}>
                        <div className={classes.Options} contentEditable={false}>
                            <Dropdown options={syntaxOptions} onSelect={onSelectSyntax} style={dropdownStyle} value={syntaxOptions[syntax]}/>
                        </div>
                        <div className={classes.Editor}>
                            <EditorBlock {...updatedProps}/>
                        </div>
                    </div>
                </Animation>
            }
            </AnimatePresence>
            
        </div>
        
    )
}

export const codeDefaultProps = {
    syntax: 'javascript',
    indent: 3
}

export const syntaxOptions = {
    plain: 'Plain',
    abap: 'ABAP',
    arduino: 'Arduino',
    bash: 'Bash',
    basic: 'Basic',
    c: 'C',
    clojure: 'Closure',
    coffeescript: 'CoffeeScript',
    cpp: 'C++',
    csharp: 'C#',
    css: 'CSS',
    dart: 'Dart',
    diff: 'Diff',
    docker: 'Docker',
    elixir: 'Elixir',
    elm: 'Elm',
    erlang: 'Erlang',
    excel: 'Excel formula',
    flow: 'Flow',
    fortran: 'Fortran',
    fsharp: 'F#',
    gherkin: 'Gherkin',
    glsl: 'GLSL',
    go: 'Go',
    graphql: 'GraphQL',
    groovy: 'Groovy',
    haskell: 'Haskell',
    html: 'HTML',
    java: 'Java',
    javascript: 'JavaScript',
    json: 'JSON',
    kotlin: 'Kotlin',
    latex: 'LaTex',
    less: 'Less',
    lisp: 'Lisp',
    livescript: 'LiveScript',
    lua: 'Lua',
    makefile: 'Makefile',
    markdown: 'Markdown',
    markup: 'Markup',
    matlab: 'MATLAB',
    nix: 'Nix',
    objectivec: 'Objective-C',
    ocaml: 'OCaml',
    pascal: 'Pascal',
    perl: 'Perl',
    php: 'PHP',
    powershell: 'PowerShell',
    prolog: 'ProLog',
    python: 'Python',
    r: 'R',
    reason: 'Reason',
    jsx: 'React JSX',
    tsx: 'React TSX',
    regex: 'Regex',
    ruby: 'Ruby',
    rust: 'Rust',
    sass: 'Sass',
    scala: 'Scala',
    scheme: 'Scheme',
    scss: 'Scss',
    shellsession: 'Shell',
    sql: 'SQL',
    swift: 'Swift',
    typescript: 'TypeScript',
    vbnet: 'VB.Net',
    verilog: 'Verilog',
    vhdl: 'VHDL',
    vba: 'Visual Basic', // visual-basic
    wasm: 'Web Assembly',
    xml: 'XML', // xml-doc
    yaml: 'YAML',
}

export const syntaxRef = {
    abap: 'abap',
    arduino: 'arduino',
    bash: 'bash',
    basic: 'basic',
    c: 'c',
    clojure: 'clojure',
    coffeescript: 'coffeescript',
    cpp: 'cpp',
    csharp: 'csharp',
    css: 'css',
    dart: 'dart',
    diff: 'diff',
    docker: 'docker',
    elixir: 'elixir',
    elm: 'elm',
    erlang: 'erlang',
    excel: 'excel-formula',
    flow: 'flow',
    fortran: 'fortran',
    fsharp: 'fsharp',
    gherkin: 'gherkin',
    glsl: 'glsl',
    go: 'go',
    graphql: 'graphql',
    groovy: 'groovy',
    haskell: 'haskell',
    html: 'html',
    java: 'java',
    javascript: 'javascript',
    json: 'json',
    kotlin: 'kotlin',
    latex: 'latex',
    less: 'less',
    lisp: 'lisp',
    livescript: 'livescript',
    lua: 'lua',
    makefile: 'makefile',
    markdown: 'markdown',
    markup: 'markup',
    matlab: 'matlab',
    nix: 'nix',
    objectivec: 'objectivec',
    ocaml: 'ocaml',
    pascal: 'pascal',
    perl: 'perl',
    php: 'php',
    powershell: 'powershell',
    prolog: 'prolog',
    python: 'python',
    r: 'r',
    reason: 'reason',
    jsx: 'jsx',
    tsx: 'tsx',
    regex: 'regex',
    ruby: 'ruby',
    rust: 'rust',
    sass: 'sass',
    scala: 'scala',
    scheme: 'scheme',
    scss: 'scss',
    shellsession: 'shellsession',
    sql: 'sql',
    swift: 'swift',
    typescript: 'typescript',
    vbnet: 'vbnet',
    verilog: 'verilog',
    vhdl: 'vhdl',
    vba: 'visual-basic', 
    wasm: 'wasm',
    xml: 'xml-doc',
    yaml: 'yaml',
}